import { formatDistanceToNow, parseISO } from 'date-fns';

// Renders an ISO-8601 timestamp as "3 minutes ago" etc. The full ISO string is
// available in the `title` tooltip for precise inspection when needed.
// Returns null-safe rendering — when `iso` is null/undefined, renders an em-dash
// placeholder so columns stay visually aligned.
export default function RelativeTime({
  iso,
  emptyPlaceholder = '—',
}: {
  iso: string | null | undefined;
  emptyPlaceholder?: string;
}) {
  if (!iso) {
    return <span className="text-zinc-400">{emptyPlaceholder}</span>;
  }
  try {
    const date = parseISO(iso);
    return <span title={iso}>{formatDistanceToNow(date, { addSuffix: true })}</span>;
  } catch {
    return <span>{iso}</span>;
  }
}
